<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:0px;">Jim Kelly was born in Irvine, Scotland in 1967. He studied computing at Bell College of Technology in Hamilton and obtained a Higher National Diploma in Computer Studies.</p><br/>
<p style="text-indent:0px;">Jim has over 30 years’ experience working in Information Technology (IT) across many industry sectors including Defence, Finance, Utilities, and Local and Central Government. He has worked in Edinburgh, London and Wellington, New Zealand.</p><br/>
<p style="text-indent:0px;">More recently, Jim is focused on Business Process Management and IT Service Management best practices, rather than on the technical side. He has obtained a number of industry recognised ITIL certifications.</p><br/>
<p style="text-indent:0px;">Jim has dual UK and New Zealand Citizenship and today he resides on the Kapiti Coast in New Zealand with his partner Carmel and their rescue dog, Rizzo.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?32bfedd8